var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('div',{staticClass:"text-h5 text-center font-weight-bold",staticStyle:{"color":"#b31312"}},[_c('v-icon',{attrs:{"large":"","color":"#B31312"}},[_vm._v("mdi-walk")]),_vm._v(" 六分鐘行走測試 ")],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }